module.exports = __webpack_public_path__ + "static/media/2021-trainingslager-luise-hanna-isa.587a55e2.jpg";